import React from 'react';
import { string, bool } from 'prop-types';
import { Helmet } from 'react-helmet';
import { Location } from '@reach/router';
import { useSiteMetadata } from 'hooks/useSiteMetadata';

import ImageFavicon from 'images/favicon.ico';

const PageHelmet = ({ title, discoverable, description }) => {
  const { baseUrl } = useSiteMetadata();
  return (
    <Location>
      {({ location }) => (
        <Helmet title={`${title} — DataCamp`}>
          <meta charset="utf-8" />
          <meta
            name="description"
            content={
              description ||
              'The data science and analytics expertise you need to level up your workforce.'
            }
          />
          <meta name="twitter:title" content={`${title} — DataCamp`} />
          <meta
            name="twitter:description"
            content={
              description ||
              'The data science and analytics expertise you need to level up your workforce.'
            }
          />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@DataCamp" />
          <meta
            name="twitter:image"
            content="https://www.datacamp.com/datacamp-sq.png"
          />
          <meta name="twitter:image:width" content="300" />
          <meta name="twitter:image:height" content="300" />
          <meta name="twitter:creator" content="@DataCamp" />
          <meta name="twitter:domain" content="www.datacamp.com" />
          <meta
            property="og:image"
            content="https://www.datacamp.com/datacamp.png"
          />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:title" content={`${title} — DataCamp`} />
          <meta
            property="og:description"
            content={
              description ||
              'The data science and analytics expertise you need to level up your workforce.'
            }
          />

          <link rel="canonical" href={`${baseUrl}${location.pathname}`} />
          <link rel="shortcut icon" type="image/x-icon" href={ImageFavicon} />
          {!discoverable && <meta name="robots" content="noindex" />}
        </Helmet>
      )}
    </Location>
  );
};

PageHelmet.defaultProps = {
  title: null,
  discoverable: true,
  description: null,
};

PageHelmet.propTypes = {
  title: string,
  discoverable: bool,
  description: string,
};

export default PageHelmet;
